import { render, staticRenderFns } from "./replayList.vue?vue&type=template&id=202124c5&scoped=true&"
import script from "./replayList.vue?vue&type=script&lang=js&"
export * from "./replayList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202124c5",
  null
  
)

export default component.exports